import axios from 'axios';

export function getCargoDuplicates() {
    return axios({
        method: 'get',
        url: '/api/v1/cargo/duplicates',
        withCredentials: true,
    })  // todo data without status ((
        .then(response => response)
        .catch(response => response);
}

export function deleteCargoDuplicate(item) {
    return axios({
        method: 'DELETE',
        url: `/api/v1/cargo/${item.id}`,
        withCredentials: true,
    }) // todo sending response.data
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/cargoes/duplicates.js